/* eslint-disable no-return-assign,react/prop-types,react/no-unused-state */

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import InjectMetaTags from 'blocks/InjectMetaTags/index';
import SplashScreen from 'blocks/SplashScreen/index';
import PageContent from 'blocks/PageContent';
import Navigation from 'blocks/Navigation';
import root from 'window-or-global';
import PageNotFound from 'pages/PageNotFound';
import get from 'lodash/get';

@inject('coreStore', 'productsStore')
@observer
class Product extends Component {
    constructor(props) {
    super(props);
    const {
      productsStore,
      match: {
        params: { slug },
      },
        } = this.props;
    productsStore.setCurrentProductByUrlSlug(slug);
  }

  componentDidUpdate(prevProps) {
    const { productsStore } = this.props;
    const prevSlug = get(prevProps, 'match.params.slug');
    const slug = get(this.props, 'match.params.slug');
    if (prevSlug !== slug) {
      productsStore.setCurrentProductByUrlSlug(slug);
      root.scrollTo(0, 0);
    }
  }

  render() {
    const {
      productsStore: { currentProduct, loadingCurrentProduct, parsedStructure },
      location: { pathname },
    } = this.props;

    if (loadingCurrentProduct) {
      return <SplashScreen />;
    }

    if (!currentProduct) {
      return <PageNotFound />;
      }

      const isSupportProducts = `${pathname}`.includes('support');

    return (
      <React.Fragment>
        <InjectMetaTags {...currentProduct.SEO} pathname={pathname} />
            <Navigation parsedStructure={parsedStructure} isSupportProducts={isSupportProducts} />
        <PageContent parsedStructure={parsedStructure} />
      </React.Fragment>
    );
  }
}
export default Product;



// WEBPACK FOOTER //
// ./src/pages/Product/index.jsx